/**
 * Russian translations for ra-core framework keys and ra-supabase auth keys.
 * Merged on top of the English catalog, so any missing key falls back to English.
 */
export const russianRaMessages = {
  ra: {
    action: {
      add_filter: "Добавить фильтр",
      add: "Добавить",
      back: "Назад",
      bulk_actions:
        "Выбрана %{smart_count} запись |||| Выбрано %{smart_count} записи |||| Выбрано %{smart_count} записей",
      cancel: "Отмена",
      clear_array_input: "Очистить список",
      clear_input_value: "Очистить",
      clone: "Дублировать",
      confirm: "Подтвердить",
      create: "Создать",
      create_item: "Создать %{item}",
      delete: "Удалить",
      edit: "Редактировать",
      export: "Экспорт",
      list: "Список",
      refresh: "Обновить",
      remove_filter: "Убрать фильтр",
      remove_all_filters: "Сбросить все фильтры",
      remove: "Убрать",
      save: "Сохранить",
      search: "Поиск",
      search_columns: "Поиск по колонкам",
      select_all: "Выбрать все",
      select_all_button: "Выбрать все",
      select_row: "Выбрать строку",
      show: "Открыть",
      sort: "Сортировка",
      undo: "Отменить",
      unselect: "Снять выбор",
      expand: "Развернуть",
      close: "Закрыть",
      open_menu: "Открыть меню",
      close_menu: "Закрыть меню",
      update: "Обновить",
      move_up: "Вверх",
      move_down: "Вниз",
      open: "Открыть",
      toggle_theme: "Переключить тему",
      select_columns: "Колонки",
      update_application: "Перезагрузить приложение",
    },
    boolean: {
      true: "Да",
      false: "Нет",
      null: "—",
    },
    page: {
      create: "Создание: %{name}",
      dashboard: "Главная",
      edit: "%{name} %{recordRepresentation}",
      error: "Что-то пошло не так",
      list: "%{name}",
      loading: "Загрузка",
      not_found: "Не найдено",
      show: "%{name} %{recordRepresentation}",
      empty: "Пока нет данных: %{name}.",
      invite: "Хотите добавить первую запись?",
      access_denied: "Доступ запрещён",
      authentication_error: "Ошибка аутентификации",
    },
    input: {
      file: {
        upload_several: "Перетащите файлы или кликните для выбора.",
        upload_single: "Перетащите файл или кликните для выбора.",
      },
      image: {
        upload_several: "Перетащите изображения или кликните для выбора.",
        upload_single: "Перетащите изображение или кликните для выбора.",
      },
      references: {
        all_missing: "Связанные данные не найдены.",
        many_missing: "Часть связанных данных недоступна.",
        single_missing: "Связанная запись недоступна.",
      },
      password: {
        toggle_visible: "Скрыть пароль",
        toggle_hidden: "Показать пароль",
      },
    },
    message: {
      about: "Справка",
      access_denied: "У вас нет прав для этой страницы",
      are_you_sure: "Вы уверены?",
      authentication_error: "Сервер аутентификации вернул ошибку.",
      auth_error: "Ошибка при проверке токена аутентификации.",
      bulk_delete_content:
        "Удалить %{name}? |||| Удалить %{smart_count} записи? |||| Удалить %{smart_count} записей?",
      bulk_delete_title:
        "Удалить %{name} |||| Удалить %{smart_count} %{name} |||| Удалить %{smart_count} %{name}",
      bulk_update_content:
        "Обновить %{name}? |||| Обновить %{smart_count} записи? |||| Обновить %{smart_count} записей?",
      bulk_update_title:
        "Обновить %{name} |||| Обновить %{smart_count} %{name} |||| Обновить %{smart_count} %{name}",
      clear_array_input: "Очистить весь список?",
      delete_content: "Удалить эту запись?",
      delete_title: "Удалить %{name} #%{id}",
      details: "Подробности",
      error: "Ошибка на клиенте: запрос не выполнен.",
      invalid_form: "Форма заполнена с ошибками. Проверьте поля.",
      loading: "Страница загружается, подождите",
      no: "Нет",
      not_found: "Такой страницы нет — проверьте адрес.",
      select_all_limit_reached:
        "Слишком много элементов. Выбраны только первые %{max}.",
      unsaved_changes: "Изменения не сохранены. Уйти без сохранения?",
      yes: "Да",
      placeholder_data_warning: "Проблема с сетью: данные могли не обновиться.",
    },
    navigation: {
      clear_filters: "Сбросить фильтры",
      no_filtered_results: "По текущим фильтрам ничего не найдено",
      no_results: "Ничего не найдено",
      no_more_results: "Страница %{page} за пределами результатов.",
      page_out_of_boundaries: "Страницы %{page} не существует",
      page_out_from_end: "Это последняя страница",
      page_out_from_begin: "Это первая страница",
      page_range_info: "%{offsetBegin}–%{offsetEnd} из %{total}",
      partial_page_range_info:
        "%{offsetBegin}–%{offsetEnd} из более чем %{offsetEnd}",
      current_page: "Страница %{page}",
      page: "Перейти на страницу %{page}",
      first: "Первая",
      last: "Последняя",
      next: "Вперёд",
      previous: "Назад",
      page_rows_per_page: "Строк на странице:",
      skip_nav: "К содержимому",
    },
    sort: {
      sort_by: "Сортировать по %{field_lower_first} (%{order})",
      ASC: "по возрастанию",
      DESC: "по убыванию",
    },
    auth: {
      auth_check_error: "Войдите, чтобы продолжить",
      user_menu: "Профиль",
      username: "Логин",
      password: "Пароль",
      email: "Email",
      sign_in: "Войти",
      sign_in_error: "Ошибка входа, попробуйте ещё раз",
      logout: "Выйти",
    },
    notification: {
      updated:
        "Запись обновлена |||| Обновлено %{smart_count} записи |||| Обновлено %{smart_count} записей",
      created: "Запись создана",
      deleted:
        "Запись удалена |||| Удалено %{smart_count} записи |||| Удалено %{smart_count} записей",
      bad_item: "Некорректная запись",
      item_doesnt_exist: "Запись не существует",
      http_error: "Ошибка связи с сервером",
      data_provider_error: "Ошибка dataProvider. Подробности в консоли.",
      i18n_error: "Не удалось загрузить переводы для выбранного языка",
      canceled: "Действие отменено",
      logged_out: "Сессия завершена, войдите снова.",
      not_authorized: "Нет доступа к этому ресурсу.",
      application_update_available: "Доступна новая версия.",
    },
    validation: {
      required: "Обязательное поле",
      minLength: "Минимум %{min} символов",
      maxLength: "Максимум %{max} символов",
      minValue: "Минимум %{min}",
      maxValue: "Максимум %{max}",
      number: "Введите число",
      email: "Введите корректный email",
      oneOf: "Допустимые значения: %{options}",
      regex: "Значение должно соответствовать формату (%{pattern})",
      unique: "Значение должно быть уникальным",
    },
    saved_queries: {
      label: "Сохранённые фильтры",
      query_name: "Название фильтра",
      new_label: "Сохранить текущий фильтр...",
      new_dialog_title: "Сохранить фильтр как",
      remove_label: "Удалить сохранённый фильтр",
      remove_label_with_name: "Удалить фильтр «%{name}»",
      remove_dialog_title: "Удалить сохранённый фильтр?",
      remove_message: "Удалить этот пункт из списка сохранённых фильтров?",
      help: "Настройте список и сохраните его на будущее",
    },
    configurable: {
      customize: "Настроить",
      configureMode: "Настроить страницу",
      inspector: {
        title: "Инспектор",
        content: "Наведите на элементы интерфейса, чтобы настроить их",
        reset: "Сбросить настройки",
        hideAll: "Скрыть всё",
        showAll: "Показать всё",
      },
      Datagrid: {
        title: "Таблица",
        unlabeled: "Колонка #%{column}",
      },
      SimpleForm: {
        title: "Форма",
        unlabeled: "Поле #%{input}",
      },
      SimpleList: {
        title: "Список",
        primaryText: "Основной текст",
        secondaryText: "Дополнительный текст",
        tertiaryText: "Третичный текст",
      },
    },
  },
  "ra-supabase": {
    auth: {
      email: "Email",
      confirm_password: "Подтвердите пароль",
      password: "Пароль",
      forgot_password: "Забыли пароль?",
      reset_password: "Сбросить пароль",
      password_reset:
        "Проверьте почту — мы отправили письмо для сброса пароля.",
      missing_tokens: "В ответе нет токенов доступа",
      back_to_login: "Назад ко входу",
      set_password: "Установить пароль",
    },
    validation: {
      password_mismatch: "Пароли не совпадают",
    },
  },
};
